export default {
  namespaced: true,
  state: {
    uploadVideo: {
      show: false,
      id: null,
      type: "", //add | edit
      playlist: null,
      emit: "",
    },
    videoDetail: {
      show: false,
      id: null,
      type: "", //add | edit
      videoDetail: null,
      thumbnail: null,
      playlist: null,
      emit: "",
    },
    playlistModal: {
      show: false,
      id: null,
      type: "", //add |edit
      emit: "",
    },
    resubmitModal: {
      show: false,
      id: null,
      emit: "",
      suffix: "",
    },
    paymentModal: {
      show: false,
      type: "", // video | playlist
      playlist: null,
      video: null,
    },
    successModal: {
      show: false,
      success: false,
      playlist: null,
      video: null,
    },
    commentModal: {
      show: false,
      comment_count: 0,
    },
  },
  getters: {
    getVideoShow: (state) => state.uploadVideo.show,
    getVideoDetailShow: (state) => state.videoDetail.show,
    getPlaylistShow: (state) => state.playlistModal.show,
    getResubmitShow: (state) => state.resubmitModal.show,
    getPaymentShow: (state) => state.paymentModal.show,
    getSuccessShow: (state) => state.successModal.show,
    getCommentShow: (state) => state.commentModal.show,
  },
  mutations: {
    TOGGLE_UPLOAD_VIDEO(state, obj) {
      // if (obj.show) {
      state.uploadVideo.id = obj.id ? obj.id : null;
      state.uploadVideo.type = obj.type ? obj.type : "";
      state.uploadVideo.playlist = obj.playlist ? obj.playlist : null;
      state.uploadVideo.emit = obj.emit ? obj.emit : "";
      // }
      state.uploadVideo.show = obj.show;
    },
    TOGGLE_VIDEO_DETAIL(state, obj) {
      // if (obj.show) {
      state.videoDetail.id = obj.id ? obj.id : null;
      state.videoDetail.type = obj.type ? obj.type : "";
      state.videoDetail.thumbnail = obj.thumbnail ? obj.thumbnail : null;
      state.videoDetail.emit = obj.emit ? obj.emit : "";
      // }
      state.videoDetail.playlist = obj.playlist ? obj.playlist : null;
      state.videoDetail.videoDetail = obj.detail ? obj.detail : null;
      state.videoDetail.show = obj.show;
    },
    TOGGLE_PLAYLIST_MODAL(state, obj) {
      if (obj.show) {
        state.playlistModal.id = obj.id ? obj.id : null;
        state.playlistModal.type = obj.type ? obj.type : "";
        state.playlistModal.emit = obj.emit ? obj.emit : "";
      }
      state.playlistModal.show = obj.show;
    },
    TOGGLE_RESUBMIT_MODAL(state, obj) {
      if (obj.show) {
        state.resubmitModal.id = obj.id ? obj.id : null;
        state.resubmitModal.emit = obj.emit ? obj.emit : "";
        state.resubmitModal.suffix = obj.suffix ? obj.suffix : "";
      }
      state.resubmitModal.show = obj.show;
    },
    TOGGLE_PAYMENT_MODAL(state, obj) {
      if (obj.show) {
        state.paymentModal.type = obj.type ? obj.type : "";
        state.paymentModal.playlist = obj.playlist ? obj.playlist : null;
        state.paymentModal.video = obj.video ? obj.video : null;
      }
      state.paymentModal.show = obj.show;
      console.log(obj, state.paymentModal);
    },
    TOGGLE_SUCCESS_MODAL(state, obj) {
      if (obj.show) {
        state.successModal.success = obj.success ? obj.success : false;
        state.successModal.video = obj.video ? obj.video : null;
        state.successModal.playlist = obj.playlist ? obj.playlist : null;
      }
      state.successModal.show = obj.show;
      // console.log(state.successModal,obj,"sjdhfgdjskfljgh")
    },
    TOGGLE_COMMENT_MODAL(state, obj) {
      if (obj.show) {
        state.commentModal.comment_count = obj.count ? obj.count : 0;
      }
      state.commentModal.show = obj.show;
    },
  },
  actions: {
    toggleUploadVideo({ commit }, obj) {
      commit("TOGGLE_UPLOAD_VIDEO", obj);
    },
    toggleVideoDetail({ commit }, obj) {
      commit("TOGGLE_VIDEO_DETAIL", obj);
    },
    togglePlaylistModal({ commit }, obj) {
      commit("TOGGLE_PLAYLIST_MODAL", obj);
    },
    toggleResubmitModal({ commit }, obj) {
      commit("TOGGLE_RESUBMIT_MODAL", obj);
    },
    togglePaymentModal({ commit }, obj) {
      commit("TOGGLE_PAYMENT_MODAL", obj);
    },
    toggleSuccessModal({ commit }, obj) {
      commit("TOGGLE_SUCCESS_MODAL", obj);
    },
    toggleCommentModal({ commit }, obj) {
      commit("TOGGLE_COMMENT_MODAL", obj);
    },
  },
};
